import type React from 'react'
import { useState } from 'react'
import styled from 'styled-components'

import ResetSection from '@/components/ResetSection/ResetSection'
import { ResetableSection } from '@/lib/apollo/mutation/reset-section'
interface Props {
  customerId: string
  applicationId: string
  subjectId: string
}

const Container = styled.div`
  padding: 5px;
  position: relative;
  z-index: 10;
  background: #fff;
  width: 100%;
  &:hover {
    cursor: pointer;
  }
  overflow-x: hidden;
`

const ToggleArea = styled.div`
  display: flex;
  justify-content: space-between;
  img {
    transform: rotate(270deg);
  }
`

const SectionButtons = styled.div`
  padding-left: 30px;
  padding-right: 30px;
`

const ResetSectionPanel: React.FC<Props> = ({ customerId, applicationId, subjectId }) => {
  const [dangerOpen, setDangerOpen] = useState(false)

  return (
    <Container data-tip="hello world">
      <ToggleArea onClick={() => setDangerOpen(!dangerOpen)}>
        <h2>Danger Zone</h2>
        <img
          src="/assets/svg/collapse.svg"
          style={{ transform: `${dangerOpen ? 'rotate(90deg)' : ''}` }}
          alt=""
        />
      </ToggleArea>
      {dangerOpen && (
        <div>
          <ResetSection
            customerId={customerId}
            applicationId={applicationId}
            subjectId={subjectId}
            buttonText="Reset Whole Subject"
            confirmResetMessage="Are you sure you want to reset all the data on this subject?"
            section={ResetableSection.All}
          />
          <SectionButtons>
            <ResetSection
              customerId={customerId}
              applicationId={applicationId}
              subjectId={subjectId}
              buttonText="Reset Identity Section"
              confirmResetMessage="Are you sure you want to reset the identity section?"
              section={ResetableSection.Identity}
            />
            <ResetSection
              customerId={customerId}
              applicationId={applicationId}
              subjectId={subjectId}
              buttonText="Reset Credit Section"
              confirmResetMessage="Are you sure you want to reset the credit section?"
              section={ResetableSection.Credit}
            />
            <ResetSection
              customerId={customerId}
              applicationId={applicationId}
              subjectId={subjectId}
              buttonText="Reset Income Section"
              confirmResetMessage="Are you sure you want to reset the income section?"
              section={ResetableSection.Income}
            />
          </SectionButtons>
        </div>
      )}
    </Container>
  )
}

export default ResetSectionPanel
